var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconConnectors = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 4.5h7m-7 3H5m-2.5 3H5m0 3H1.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7.086a1 1 0 0 1 .707.293l1.914 1.914a1 1 0 0 1 .293.707V4.5m-1 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1.85-3.867.294.969a.663.663 0 0 0 .783.454l.981-.227a.893.893 0 0 1 .85 1.478l-.687.741a.667.667 0 0 0 0 .908l.687.74a.893.893 0 0 1-.85 1.48l-.981-.228a.663.663 0 0 0-.783.454l-.295.965a.886.886 0 0 1-1.698 0l-.295-.969a.663.663 0 0 0-.783-.454l-.981.227a.892.892 0 0 1-.85-1.478l.687-.741a.667.667 0 0 0 0-.908l-.687-.74a.893.893 0 0 1 .85-1.48l.981.228a.663.663 0 0 0 .783-.454l.295-.969a.886.886 0 0 1 1.698.004"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 4.5h7m-7 3H5m-2.5 3H5m0 3H1.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7.086a1 1 0 0 1 .707.293l1.914 1.914a1 1 0 0 1 .293.707V4.5m-1 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1.85-3.867.294.969a.663.663 0 0 0 .783.454l.981-.227a.893.893 0 0 1 .85 1.478l-.687.741a.667.667 0 0 0 0 .908l.687.74a.893.893 0 0 1-.85 1.48l-.981-.228a.663.663 0 0 0-.783.454l-.295.965a.886.886 0 0 1-1.698 0l-.295-.969a.663.663 0 0 0-.783-.454l-.981.227a.892.892 0 0 1-.85-1.478l.687-.741a.667.667 0 0 0 0-.908l-.687-.74a.893.893 0 0 1 .85-1.48l.981.228a.663.663 0 0 0 .783-.454l.295-.969a.886.886 0 0 1 1.698.004"
  }));
});
export default SvgIconConnectors;
export const raw = __webpack_public_path__ + "static/media/IconConnectors.4ff36930c619e4f101e58023fbfb9e1d.svg";